// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"44a677a6","160":"f5486471","208":"1b1d6f4b","293":"f151acd6","516":"2fed3448","519":"5c8cbc76","917":"f8bce108","946":"8a3f160f"}[chunkId] + ".chunk.js";
};